/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Select from "react-select";

import { Container, MyInput, CBody, CompanyImage } from "./style";
import { customStyles } from "../../style/selectStyles";
import { zoneData } from "../../helpers/selectTimezone.jsx";
import { Question } from "../../components/Question/index";
import { AiOutlineEdit } from "react-icons/ai";
import noImage from "./assets/noImage.jpg";

function UserPropsConfig({ data, updateTable, setAllData, canGetData }) {
	const [inputsValues, setInputsValues] = useState({});
	const [previewImage, setPreviewImage] = useState(noImage);
	const [timeZone, setTimezone] = useState({
		label: "America/Sao_Paulo",
		value: "−03:00",
	});

	const refreshData = () => {
		let zone;
		if (data?.timeZone) {
			zone = zoneData.find((item) => item.label === data?.timeZone);
		}
		setTimezone({
			label: zone ? zone.label : "",
			value: zone ? zone.value : "",
		});
		setInputsValues({
			portalId: data.portalId ? data.portalId : "",
			dispatchMessageWithRandomicNumber: data.dispatchMessageWithRandomicNumber
				? data.dispatchMessageWithRandomicNumber
				: false,
			dispatchLimit: data.dispatchLimit ? data.dispatchLimit : 0,
			name: data?.name ? data?.name : "",
			inactivityMessage: data?.inactivityMessage ? data?.inactivityMessage : "",
			inboxPropertyShow: data?.inboxPropertyShow ? data?.inboxPropertyShow : "",
			messageNoOnlineOperators: data?.messageNoOnlineOperators
				? data?.messageNoOnlineOperators
				: "",
			operatorLimit: data?.operatorLimit ? data?.operatorLimit : "",
			askReceiveWhats: data?.askReceiveWhats ? data?.askReceiveWhats : false,
			multipleDDI: data?.multipleDDI ? data?.multipleDDI : false,
			landbotAgentToken: data?.landbotAgentToken ? data?.landbotAgentToken : "",
			channelLandBotToken: data?.channelLandBotToken
				? data?.channelLandBotToken
				: "",
		});
		if (data.accountLogo) {
			setPreviewImage(data.accountLogo);
		}
	};

	useEffect(() => {
		if (data) {
			refreshData();
		}
	}, [data]);

	const handleInputChange = (fieldType = "input", field) => {
		return (e) => {
			if (fieldType === "select") {
				setInputsValues({
					...inputsValues,
					[field]: e.value,
				});
				return;
			}
			const { name, value, type, checked, files } = e.target;
			if (fieldType === "file") {
				setInputsValues({
					...inputsValues,
					[name]: files[0],
				});
				return;
			}
			if (type === "checkbox") {
				setInputsValues({
					...inputsValues,
					[name]: checked,
				});
				return;
			}
			setInputsValues({
				...inputsValues,
				[name]: value,
			});
		};
	};

	useEffect(() => {
		if (canGetData[0] === true) {
			setAllData[1]({
				_id: data?._id && data._id,
				...setAllData[0],
				...inputsValues,
				timeZone: timeZone.label,
				timezone: timeZone.value.split(" ")[0],
			});
			canGetData[1](false);
		}
	}, [canGetData[0]]);

	const uploadProfilePhoto = (file) => {
		setPreviewImage(URL.createObjectURL(file));
	};

	return (
		<Container>
			<CompanyImage>
				<h4>{inputsValues?.name}</h4>
				<form>
					<img src={previewImage} alt="Account Logo" />
					<input
						name="picture"
						id="uploadPhoto"
						type="file"
						style={{
							visibility: "hidden",
							width: "0",
							margin: "0",
							padding: "0",
							height: "0",
						}}
						onChange={(e) => {
							uploadProfilePhoto(e.target.files[0]);
							handleInputChange("file")(e);
						}}
					/>
					<label htmlFor="uploadPhoto">
						<AiOutlineEdit />
					</label>
				</form>
			</CompanyImage>
			<hr />
			<CBody basic>
				<label>{"Nome da conta do cliente"}</label>
				<div>
					<MyInput
						value={inputsValues?.name}
						onChange={handleInputChange()}
						name="name"
					/>
				</div>
				<label>
					{"Mensagem enviada após 2 horas de inatividade do contato"}
					{/* se for colocar a imagem na pasta, colocar em /public/
									e colocar igual aqui embaixo
								se for url, passar como string normal
							 */}
					<Question
						explanationMessage={
							"Essa mensagem não será enviada caso a conversa esteja com o atendente." +
							"Caso não queria enviar esse aviso, deixe-o em branco"
						}
					/>
				</label>
				<div>
					<MyInput
						onChange={handleInputChange()}
						name="inactivityMessage"
						value={inputsValues?.inactivityMessage}
					/>
				</div>
				<label>
					{"Nome interno da propriedade exibida na caixa de entrada"}
				</label>
				<div>
					<MyInput
						value={inputsValues?.inboxPropertyShow}
						onChange={handleInputChange()}
						name="inboxPropertyShow"
					/>
				</div>
				<label>{"Portal Id do hubspot"}</label>
				<div>
					<MyInput
						value={inputsValues?.portalId}
						onChange={handleInputChange()}
						name="portalId"
					/>
				</div>
				<label>Channel landbot token</label>
				<div>
					<MyInput
						value={inputsValues?.channelLandBotToken}
						onChange={handleInputChange()}
						name="channelLandBotToken"
					/>
				</div>
				<label>Landbot agent token</label>
				<div>
					<MyInput
						value={inputsValues?.landbotAgentToken}
						onChange={handleInputChange()}
						name="landbotAgentToken"
					/>
				</div>
				<label>
					{"Mensagem enviada na ausência de atendentes online."}
					<Question
						explanationMessage={
							"Caso não queria enviar esse aviso, deixe-o em branco"
						}
					/>
				</label>
				<div>
					<MyInput
						value={inputsValues?.messageNoOnlineOperators}
						onChange={handleInputChange()}
						name="messageNoOnlineOperators"
					/>
				</div>
				<label>
					{"Máximo de atendentes que poderão ser cadastrados por essa conta"}
				</label>
				<div>
					<MyInput
						value={inputsValues?.operatorLimit}
						onChange={handleInputChange()}
						name="operatorLimit"
					/>
				</div>
				<label>
					Limite de disparos
					<Question
						explanationMessage={
							"Limite de disparos que podem ser efetuados por dia"
						}
					/>
				</label>
				<div>
					<MyInput
						value={inputsValues?.dispatchLimit}
						type="number"
						onChange={handleInputChange()}
						name="dispatchLimit"
						placeholder={"Insira o limite de disparos de sua conta"}
					/>
				</div>
				<label>{"Fuso horário"}</label>
				<div>
					{zoneData && (
						<section>
							<Select
								styles={customStyles}
								placeholder={""}
								defaultValue={{
									label: timeZone?.value,
									value: timeZone?.value,
								}}
								options={zoneData}
								onChange={(e) =>
									setTimezone({ label: e.label, value: e.value })
								}
								value={{ label: timeZone.label, value: timeZone.value }}
								noOptionsMessage={() => ""}
							/>
						</section>
					)}
				</div>
				<hr />
				<div>
					<label>
						{
							"Impedir o disparo caso o contato opte pelo não recebimento de Whatsapp"
						}
						<Question
							explanationMessage={
								"Caso essa opção estiver marcada, o disparo estará condicionado ao preenchimento da propriedade 'Bloquear Recebimento de Whatsapp'"
							}
						/>
					</label>
					<input
						type="checkbox"
						checked={inputsValues?.askReceiveWhats}
						onChange={handleInputChange()}
						name="askReceiveWhats"
					/>
				</div>
				<br />
				<div>
					<label>
						Disparar mensagem para contato através de números randômicos
					</label>
					<input
						type="checkbox"
						checked={inputsValues?.dispatchMessageWithRandomicNumber}
						onChange={handleInputChange()}
						name="dispatchMessageWithRandomicNumber"
					/>
				</div>
				<br />
				<div>
					<label>
						{"Permitir multi DDI"}
						<Question
							explanationMessage={
								"Se a base de contatos conter números com DDI diferente de 55, essa propriedade deverá ser marcada."
							}
						/>
					</label>
					<input
						type="checkbox"
						checked={inputsValues?.multipleDDI}
						onChange={handleInputChange()}
						name="multipleDDI"
					/>
				</div>
				<hr />
			</CBody>
		</Container>
	);
}
export default UserPropsConfig;
